var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 35,
    viewBox: "0 0 22 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_5887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5417 1.45801H4.875C2.45417 1.45801 0.5 3.41217 0.5 5.83301V29.1663C0.5 31.5872 2.45417 33.5413 4.875 33.5413H16.5417C18.9625 33.5413 20.9167 31.5872 20.9167 29.1663V5.83301C20.9167 3.41217 18.9625 1.45801 16.5417 1.45801ZM13.625 30.6247H7.79167V29.1663H13.625V30.6247ZM18.3646 26.2497H3.05208V5.83301H18.3646V26.2497Z",
    fill: "#2091F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_5887"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 34,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.46a93980d3569ea5bbd70107dbaa8f28.svg";
export { ForwardRef as ReactComponent };